import Store from '@/store';
import SLSItemExValoresClient from '@/api/SistemaDKP/sls-item-ex-valores.client';
import { ErrorMessage } from '@/libs/Error';

export default class SLSitemExValoresService {
  constructor() {
    this.client = new SLSItemExValoresClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index() {
    try {
      const { data } = await this.client.index();
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Campo Customizado');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Campo Customizado');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Campo Customizado');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Campo Customizado');
    }
  }

  async findAllByItem(id_item) {
    try {
      return await this.client.findAllByItem(id_item);
    } catch (error) {
      this.error.message(error, 'Erro ao listar os Valores do campo');
    }
  }
}
